import React from 'react';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Section from '../../../shared/Section/Section';
import styles from './styles';
import PointsList from '../../../shared/PointsList/PointsList';

function HowDoesBootcampWork({
  images,
  image,
  pointsLists,
  title = 'Как устроен буткемп',
}) {
  const isBelowSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return (
    <Section
      title={title}
      theme={'light'}
      customStyles={{
        padding: {
          xs: '34px 0 40px 0',
          lg: '40px 0 64px 0',
        },
      }}
      withoutBg
    >
      <Grid container spacing={7}>
        <Grid item xs={12} xl={8} display={'flex'} flexWrap={'wrap'}>
          {pointsLists.map(({ title, list }, index) => {
            const pointsImage =
              index === 0
                ? images[image]
                : isBelowSm && images['howBootcampWorks/codebg'];
            return (
              <Grid
                item
                xs={12}
                md={6}
                display={'flex'}
                flexDirection={'column'}
                key={title}
                sx={{
                  border: {
                    xs: 'solid 1px rgba(255, 255, 255, 0.90)',
                    md: 'none',
                  },
                  backgroundColor: {
                    xs: 'rgba(255, 255, 255, 0.25);',
                    md: 'transparent',
                  },
                  borderRadius: 2,
                  ':not(:last-child)': { mb: { xs: 1, lg: 0 } },
                  p: { xs: '24px 16px 32px 16px', lg: 0 },
                }}
              >
                <Typography
                  variant="desktopH4"
                  color={'kit.text.h'}
                  sx={{ mb: 3 }}
                >
                  {title}
                </Typography>
                <PointsList
                  list={list}
                  textProps={{
                    fontSize: 14,
                    zIndex: 1,
                    color: 'kit.text.secondary',
                  }}
                />
                {pointsImage && (
                  <Box
                    sx={{
                      position: index === 1 ? 'absolute' : 'none',
                      bottom: 9,
                      right: 22,
                      mt: { xs: 3, lg: 5 },
                      mb: index === 1 ? 0 : -3,
                      maxWidth: { xs: 289, sm: 312, md: 380 },
                    }}
                  >
                    <GatsbyImage image={getImage(pointsImage)} alt="img" />
                  </Box>
                )}
              </Grid>
            );
          })}
        </Grid>
      </Grid>
      <Box
        sx={{
          width: 529,
          position: 'absolute',
          top: 0,
          right: 50,
          display: { xs: 'none', xl: 'block' },
        }}
      >
        <GatsbyImage
          image={getImage(images['howBootcampWorks/howbootcampworks'])}
          imgStyle={styles.image}
          alt=""
        />
      </Box>
    </Section>
  );
}

export default HowDoesBootcampWork;
